window.addEventListener('load', () => {
    let triggers = document.querySelectorAll('.dino-animate-trigger');
    let screenDino = document.querySelectorAll('.dino-animate-translate-y');
    let ogDino = document.getElementById('ogDino');
    let possiblePositions = ['tl-tr', 'tr-tl', 'tr-br','br-tr', 'br-bl', 'bl-br', 'bl-tl', 'tl-bl'];
    let activeDinoClones = 0;

    if (!triggers.length || !ogDino) return;

    function spawnDino() {
        if (activeDinoClones === 0) {
            for (let dino of screenDino) {
                dino.style.transform = 'translateY(100px)';
            }
            setTimeout(() => {
                document.getElementById('dinoGrowl').play();
            }, 500);
        }

        activeDinoClones = activeDinoClones + 1;
        const dinoClone = ogDino.cloneNode(true);
        document.body.appendChild(dinoClone);
        dinoClone.removeAttribute('id');

        const randomizedPosition = Math.floor(Math.random() * possiblePositions.length);
        const position = possiblePositions[randomizedPosition];

        dinoClone.classList.remove('hidden');
        dinoClone.classList.add('dino-position-' + position);
        setTimeout(() => {
            dinoClone.classList.add('dino-animate-' + position);
        }, 50);

        setTimeout(() => {
            dinoClone.remove();
            activeDinoClones = activeDinoClones - 1;
            if (activeDinoClones === 0) {
                for (let dino of screenDino) {
                    dino.style.transform = '';
                }
            }
        }, 1900);
    }

    function isInTrigger(clientX, clientY) {
        for (let trigger of triggers) {
            const rect = trigger.getBoundingClientRect();
            if (clientX >= rect.left && clientX <= rect.right &&
                clientY >= rect.top && clientY <= rect.bottom) {
                return true;
            }
        }
        return false;
    }

    // SVG pointer-events can't propagate through pointer-events:none HTML ancestors
    // via normal hit-testing, so we intercept at document level and match against
    // the trigger's bounding rect.
    document.addEventListener('click', (e) => {
        if (isInTrigger(e.clientX, e.clientY)) spawnDino();
    });

    document.addEventListener('mousemove', (e) => {
        document.documentElement.style.cursor = isInTrigger(e.clientX, e.clientY) ? 'pointer' : '';
    });
});
